export default __webpack_public_path__ + "assets/f75e30ebebbb89a47710739fc1d36573.woff";